import type { IconType } from 'react-icons';
import {
  LuBeef,
  LuEgg,
  LuFish,
  LuHam,
  LuLeaf,
  LuMilk,
  LuNut,
  LuWheat,
  LuWine,
} from 'react-icons/lu';
import { PiShrimp } from 'react-icons/pi';

import { type DietGlyph, dietGroup, type DietGroupId } from '@/store/persons/allergiesDiet';

const GLYPHS: Record<DietGlyph, IconType> = {
  nut: LuNut,
  milk: LuMilk,
  egg: LuEgg,
  fish: LuFish,
  shrimp: PiShrimp,
  wheat: LuWheat,
  leaf: LuLeaf,
  meat: LuBeef,
  pork: LuHam,
  wine: LuWine,
};

/** The glyph a common pick carries, if it has one. */
export const dietGlyphIcon = (group: DietGroupId, code: string) => {
  const glyph = dietGroup(group).quick.find((pick) => pick.code === code)?.glyph;
  const Icon = glyph && GLYPHS[glyph];
  return Icon ? <Icon /> : undefined;
};

/** An allergy is painted as an alert, a dietary exclusion as a caution. */
export const dietChipVariant = (group: DietGroupId) => (group === 'allergy' ? 'alert' : 'caution');
